import React, { useState, useRef, useEffect, useCallback } from 'react';
import { ReactTabulator } from 'react-tabulator';
import DatePicker from "react-datepicker";
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { clearUserState } from '../../reducers/userReducers.jsx';
import { clearMenuState } from '../../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../../reducers/langCodeReducers.jsx';
import loader from '../../assets/img/loading.gif'
import { API_BASE_URL } from '../../config/app-axios.jsx';
import API from '../../api/api.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';

// ZALO 사용 내역 조회
// Tabulator columns 목록
const initializeColumns = (t) => {
	return [		
		{ title: t('ZNS_REPORT.일자', { defaultValue: '일자' }), field: 's_date', headerHozAlign: 'center', hozAlign: 'center', width:150 , formatter:function(cell, formatterParams, onRendered){
			var value = cell.getValue();

			if (!value) {
				return '';
			}

			value = moment(value).format("DD/MM/YYYY");
			return value;
		} },
		{ title: t('COLLECTION_MANAGEMENT.지점', { defaultValue: '지점명' }), field: 'branch_name', headerHozAlign: 'center', hozAlign: 'center', width:320 },
		{ title: t('ZNS_REPORT.구분', { defaultValue: '구분' }), field: 'tran_type', headerHozAlign: 'center', hozAlign: 'center', width:250 }, 
		{ title: t('ZNS_REPORT.건수', { defaultValue: '건수' }), field: 'cnt', headerHozAlign: 'center', hozAlign: 'right', width: 200 , formatter:"money", formatterParams:{ decimal:",", thousand:".", precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", precision:false } },
	];
};

// ZALO 사용 내역 조회
const Report003 = () => {
	const { t, i18n } = useTranslation();
	const dispatch    = useDispatch();
	const defaultDate = new Date();
	const tableRef    = useRef(null);

	// 초기 값
	const [loading, setLoading]                       = useState(false);
	const [startDate, setStartDate]                   = useState(defaultDate.setMonth(defaultDate.getMonth() - 1));
	const [endDate, setEndDate]                       = useState(new Date());
	// const userInfo                                    = getUserInfo(store.getState());
	// const [selectOptions,setSelectOptions]            = useState([]);                   
	// const [applicationChannel, setApplicationChannel] = useState('');
	// const [customerName, setCustomerName]             = useState('');
	const [rowsPerPage, setRowsPerPage]               = useState(100);
	// const [filterField, setFilterField]               = useState('loan_application_id');
	// const [filterType, setFilterType]                 = useState('like');
	// const [filterValue, setFilterValue]               = useState('');
	const [columns, setColumns]                       = useState(initializeColumns(t));
	const [tran_type, setTranType]                    = useState('');
	const [totalCount, setTotalCount]                 = useState(0);
	
	// remote 방식에 따른 페이징 처리
	const apiUrl                                      = API_BASE_URL;
	const userInfo                                    = getUserInfo(store.getState());
	const branchType                 				  = useState(userInfo.branch_type);
	const token                                       = userInfo?.access_token;
	const [selectBranch,setSelectBranch]              = useState('');
	const [selectOptions1,setSelectOptions1]          = useState([]);

	const [selectOptions, setSelectOptions] = useState([]);
	const [template, setTemplate]           = useState('');

	// 내용 변경
    const handleChangeSelect = (e) => {
		setTemplate(e.target.value);
	};


	// 지점 정보 변경
	const handleChangeBranch = (e) => {
		setSelectBranch(e.target.value);
	};
	// ①. 강제로 쿠키 삭제를 통한 로그인 정보가 없는 경우
    const persistInfo = sessionStorage.getItem('persist:login');

    if (!persistInfo) {
        window.location.href = '/login';
    };

	// ②. 토큰 만료 체크 루틴
	if (token) {
		const decodedToken            = jwtDecode(token);
		const expirationTimeInSeconds = decodedToken.exp;
		const currentTimeInSeconds    = Math.floor(Date.now() / 1000);

		if (expirationTimeInSeconds < currentTimeInSeconds) {
			// 토큰이 만료되었을 경우 로그인 페이지로 리디렉션
			dispatch(clearUserState());
			dispatch(clearMenuState());
			dispatch(clearLangCodeState());
			localStorage.removeItem('langCodeInfo');
			window.location.href = '/login';
		};
	};

	// i18 선택된 언어에 따라 필요한 필드 값 번역
	const translateItem = useCallback((item, language) => ({
		...item,
		// loan_application_status : t(`LOAN_APPLICATION_STATUS.${item.loan_application_status}`, { lng: language }),
		tran_type: t(`ZALO_TEMPLATE_TYPE.${item.tran_type}`, { lng: language }),
		application_channel     : item.application_channel ? t(`APPLICATION_CHANNEL.${item.application_channel}`, { lng: language }) : '',
		collateral_type         : item.collateral_type ? t(`COLLATERAL.${item.collateral_type}`, { lng: language }) : '',
	}), [t]);

	// // 접수채널 변경
	// const handleChangeChannel = (e) => {
	// 	setApplicationChannel(e.target.value);
	// };

	// 오늘 버튼 액션
	const handleChangeTodayDate = () => {
		setStartDate(new Date());
		setEndDate(new Date());
	};

	//상태 box 변경
	const handleStatusChange = (e) => {
		const selectedValue = e.target.value;
		setTranType(selectedValue);
	};

	// 지난달 버튼 액션
	const handleChangeYesterDayDate = () => {
		const today     = new Date();
		// const yesterday = new Date(today.setDate(today.getDate() - 1));
		const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
		const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
		setStartDate(firstDayLastMonth);
		setEndDate(lastDayLastMonth);
	};

	// 이번달 버튼 액션
	const handleChangeMonthDate = () => {
		const today       = new Date();
		// const oneMonthAgo = today.setMonth(today.getMonth() - 1);
		const firstDayThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		setStartDate(firstDayThisMonth);
		setEndDate(new Date());
	};

	// 시작일 값 변경
	const handleChangeStartDate = (date) => {
		setStartDate(date);
	};

	// 종료일 값 변경
	const handleChangeEndDate = (date) => {
		setEndDate(date);
	};


	// 접수 채널 선택 옵션
	const fetchBaseOptions = async () => {			
		try {
			const data = await API.fetchBaseOptions();
			
			// const options       = data.filter(item => item.code_nick_name === '접수채널');
			// const result        = options.map(item => [item.code,item.code_se]);
			
			const options1      = data.filter(item => item.code_nick_name === '지점');
			const SelectOptions = options1.map(item => [item.code,item.code_se]);

			// setSelectOptions(result);
			setSelectOptions1(SelectOptions);

			if (SelectOptions.length === 1) {
				setSelectBranch(SelectOptions[0][0]);
			};

		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Tabulator Options
	// options 객체를 상태로 관리
	const [options, setOptions] = useState({
		ajaxURL     : `${apiUrl}/report/report_003`,
		ajaxConfig  : {
			method  : 'GET',
			headers : {
				'Content-Type' : 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		},
		ajaxParams : {
			startDate               : moment(startDate).format('YYYY-MM-DD'),
			endDate                 : moment(endDate).format('YYYY-MM-DD'),
			tran_type 				: tran_type,
			branch_code             : selectBranch,
			page                    : tableRef.current && tableRef.current.table ? tableRef.current.getPage() : 1,
			size                    : tableRef.current && tableRef.current.table ? tableRef.current.getPageSize() : 100, // 페이지 크기 정보
		},
		layout                 : "fitColumns",
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage,
		paginationSizeSelector : [20, 40, 60, 80, 100],
		ajaxResponse : function (url, params, response) {

			// 값이 변경되면 직접 타이핑 하는 성명 칸은 초기화시키기
			// setCustomerName('');

			const total_count    = response.total_count || 0;
			const translatedData = response.data.map(item => translateItem(item, i18n.language));
			const responseData   = {
				last_page : response.last_page,
				data      : translatedData,
			};

			setTotalCount(total_count);

			return responseData;
		}
	});

	// 로딩 중일 때 이전의 pagination 관련 정보를 유지하도록 설정
	const loadingOptions = {
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage, // 이전 페이지 사이즈를 유지
		paginationSizeSelector : [20, 40, 60, 80, 100],
	};
	
	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = useCallback(		
		async () => {
			setLoading(true);

			// ReactTabulator의 내부 로직을 사용하여 API 호출
			try {
				// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
				const url  = new URL(options.ajaxURL);
				url.search = new URLSearchParams({
					...options.ajaxParams,
					// customerName : customerName,
					page         : tableRef.current?.getPage(),
					size         : tableRef.current?.getPageSize()
				});

				const data = await fetch(url, {
					method  : options.ajaxConfig.method,
					headers : options.ajaxConfig.headers,
				});

				const responseData = await data.json();

				// 전달 받은 총 데이터 건수
				const total_count = responseData.total_count || 0;
		
				// 번역이 필요한 부분
				const translatedData = responseData.data.map(item => translateItem(item, i18n.language));
		
				// 페이징 및 데이터 리턴
				const updatedData = {
					last_page : responseData.last_page, // 전체 페이지 수 계산
					data      : translatedData, // 실제 테이블 데이터
				};

				// 총 건수를 화면에 표현하기 위해서
				setTotalCount(total_count);

				// 테이블 데이터를 초기화하고 새로운 데이터로 업데이트
				if (tableRef.current) {
					// 데이터 로드가 완료된 후에만 테이블 데이터를 변경하도록 함
					if (!loading) {
						tableRef.current.clearData();
						tableRef.current.setData(updatedData.data || []);
					}
				}

				setLoading(false);

			} catch (error) {
				console.error('Error in fetchLoan001DataUpdateState:', error);
				setLoading(false);
			} 
		}, [options, i18n.language, translateItem, tableRef, loading]
	);
    // 내용
    useEffect(() => {
        const fetchBaseOptions = async () => {
			try {
				const data     = await API.fetchBaseOptions();

				const options  = data.filter(item => item.code_nick_name === '내용');
				const result   = options.map(item => [item.code,item.code_se]);
				
				setSelectOptions(result);
                setTemplate(result[0][0])
                
			} catch (error) {
				console.error('Error fetching Base Options data:', error);
			}
		};

		fetchBaseOptions();
    }, []);

	// 선택 조건 불러오기
	useEffect(() => {
		fetchBaseOptions();
	}, []);

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					startDate               : moment(startDate).format('YYYY-MM-DD'),
					endDate                 : moment(endDate).format('YYYY-MM-DD'),
					tran_type 				: template,
					branch_code             : selectBranch
				},
			};
			return updatedOptions;
		});
	}, [startDate, endDate, template, selectBranch]);

	// i18 언어에 맞춰서 자동 갱신 (컬럼명, Grid 내용)
	useEffect(() => {
		setColumns(initializeColumns(t));
	}, [i18n.language, t, options, handleQuery, tran_type]);

	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	// const updateFilter = () => {
	// 	if (tableRef.current) {
	// 		tableRef.current.setFilter(filterField, filterType, filterValue);
	// 	}
	// };

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	// const handleKeyUp = () => {
	// 	updateFilter();
	// };

	// UI
	// console.log("branchType:", branchType);  // 현재 branchType 값 확인
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('ZNS_REPORT.ZNS사용현황', { defaultValue: 'ZNS 사용현황' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body m-1'>
				<div className="panel-body">
					<div className="row ms-0">

						<div className="form-group col-lg-4 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="date_id">
								<i className="bi bi-calendar3"></i> {t('ZNS_REPORT.일자', { defaultValue: '조회일자' })}
								{/* <div className="mb-0">
								</div>  */}
								<span className='ms-4'>
									<button type="button" className="btn btn-success btn-xs me-1 w-100px ms-1" onClick={handleChangeTodayDate}>{t('LOAN_APPLICATION.오늘', { defaultValue: '오늘' })}</button>
									<button type="button" className="btn btn-success btn-xs me-1 w-100px" onClick={handleChangeYesterDayDate}>{t('LOAN_APPLICATION.지난달', { defaultValue: '지난달' })}</button>
									<button type="button" className="btn btn-success btn-xs w-100px" onClick={handleChangeMonthDate}>{t('LOAN_APPLICATION.이번달', { defaultValue: '이번달' })}</button>
								</span>
							</label>

							<div className="input-group input-daterange justify-content-center">
								<div className='col'>
									<DatePicker
										className='form-control'
										selected={startDate}
										onChange={handleChangeStartDate}
										dateFormat="dd/MM/yyyy"
									/>
								</div>

								<div className="col-auto">
									<span className="input-group-text input-group-addon"> ~ </span>
								</div>

								<div className='col'>
									<DatePicker
										className='form-control'
										selected={endDate}
										onChange={handleChangeEndDate}
										dateFormat="dd/MM/yyyy"
									/>
								</div>
							</div>
						</div>

						<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="site_code_id">
								<i className="bi bi-buildings "></i> {t('ZNS_REPORT.구분', { defaultValue: '구분' })}
							</label>
				            {/* <SelectInput options={selectOptions} onChange={handleChangeSelect} t={t} /> */}
							<select onChange={handleChangeSelect}
								className='form-select'
								// onChange={onChange}
								value={template}
								style={{ width: '190' }}
							>
								{ 
									<option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
								}
								{selectOptions.map((option, index) => (
									<option key={index} value={option[0]}>
										{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
									</option>
								))}
							</select>
						</div>
						<div className="form-group col-lg-1 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="acct_nickname_id">
								<i className="bi bi-pen"></i> {t('COLLECTION_MANAGEMENT.지점', { defaultValue: '지점' })}
							</label>
							
							<select onChange={handleChangeBranch} value={selectBranch} className="form-select" id="site_code_id" style={{ width: '200px'  }}>
								{branchType?.[0] === 'HEAD' 
									? <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
									: ''
								}
								{selectOptions1.map((option, index) => (
									<option key={index} value={option[0]}>
										{/* {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })} */}
										{option[1]}											
									</option>
								))}
							</select>
						</div>
						<div className="form-group col-lg-3 col-md-12 col-xs-12 mb-2 ps-0 rounded-2"></div>

						{/* <div className="form-group col-lg-2 col-md-12 col-xs-12"></div> */}

						<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
							<div className="mb-3"></div>
							<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
						</div>

						
					</div>
				</div>

				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}

				{/* Tabulator */}
				<div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>{t(`LOAN_APPLICATION.총 {{count}}건`, { count: totalCount, defaultValue: '총 {{count}}건' })}</div>
				<ReactTabulator
					key         = {i18n.language + JSON.stringify(columns) + JSON.stringify(options)} // 언어 변경 및 옵션 변경에 따라 컴포넌트 리렌더링
					onRef       = {(r) => (tableRef.current = r.current)}
					columns     = {columns}
					options     = {loading ? loadingOptions : options} // 로딩 중일 때는 이전의 pagination 관련 정보를 유지하고 데이터를 변경하지 않도록 함
					placeholder = "No Data Found"
					className   = "responsive-tabulator"
				/>
			</Card.Body>

			<div className="card-footer d-flex justify-content-start mt-auto">
				{/* <button type="button" className="btn btn-outline-info mb-1 me-1 w-auto">{t('LOAN_APPLICATION.대출신청', { defaultValue: '대출신청' })}</button>
				<button type="button" className="btn btn-outline-success me-1 mb-1 w-auto">{t('LOAN_DISBURSEMENT.대출실행', { defaultValue: '대출실행' })}</button> */}
			</div>
		</ Card>
	);
};

export default Report003;